import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';
import styles from './index.module.scss';

const propsEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
};

const PickPackInfoToolTip = props => {
  const [tooltipData, setTooltipData] = useState<Record<string,any>>({});
  
  useEffect(() => {
    setTooltipData(props.pickPackInfo);
  }, []);

  
  const getToolTip = () => (
    <div className={styles['pick-pack-tooltip']}>
      {!tooltipData ? (
        <div>No Pick Pack List Found</div>
      ) : (
        <div className={styles['column-section']}>
          <div className={styles['info-group']}>
            <div>Pick Pack List ID</div>
            <div>{tooltipData.objectId}</div>
          </div>
          <div className={styles['info-group']}>
            <div>Name</div>
            <div>{tooltipData.name}</div>
          </div>
          <div className={styles['info-group']}>
            <div>Number</div>
            <div>{tooltipData.pickPackListNo}</div>
          </div>
        </div>
      )}
    </div>
  );
  
  return (
    <>
      <ReactTooltip
        id={'pick-pack-list-detail'}
        multiline={true}
        getContent={() => getToolTip()}
        place={'left'}
        type={'dark'}
        effect={'solid'}
        globalEventOff={'click'}
        afterHide={props.hideToolTip}
      />
    </>
  );
};

export default React.memo(PickPackInfoToolTip, propsEqual);